import axios from "axios";
import { UserValue } from "../contexts/user";
import { useContext, useMemo } from "react";
import { useParams } from "react-router-dom";

export default function useAdminRequest() {
  const { jwt } = useContext(UserValue);
  const { appId } = useParams();

  const request = useMemo(() => {
    return axios.create({
      baseURL: `http://localhost:5050/app/${appId}/development/admin`,
      headers: { Authorization: `Bearer ${jwt}` },
    });
  }, [jwt, appId]);

  return request;
}

//http://localhost:5050
//https://api.brevitybuilder.com
